module.exports = __webpack_public_path__ + "static/media/education-object-3-1-2.f42bf7e1.svg";